'use client'

import useToast from '@/hooks/useToast';
import { ButtonHTMLAttributes } from 'react';

interface BackProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    content: string;
    message?: string
}

export default function CopierButton({ content, message, ...props }: BackProps) {
    const { successToast } = useToast()
    const handleCopyClick = () => {
        if (navigator.clipboard) {
            navigator.clipboard
                .writeText(content)
                .then(() => {
                    successToast(message || 'successfully copied!')
                })
                .catch((err) => {
                    console.error("Failed to copy text: ", err);
                });
        } else {
            console.error("Clipboard API not supported");
        }
    };

    return (
        <button onClick={(e) => {
            props.onClick && props.onClick(e)
            handleCopyClick()
        }}
            {...props}>
            {props.children}
        </button>
    );
}